import React from 'react';
import { LangContext } from '../../contexts/lang.context';
import { UserInfoContext } from '../../contexts/userInfo.context';
import { SectionTitle } from '../ui';
import { Box } from '@material-ui/core';
import { Symptoms } from '../../constants';
import { Statistic } from '../../models/interfaces';
import { StatisticDegree } from './StatisticDegree';

export const StatisticSection: React.FC = () => {
  const { STATISTIC_SECTION } = React.useContext(LangContext).currentLangData;
  // crate default statistic
  const defaultStatistic: Statistic[] = [{ degree: 1, totalNum: 0, created_at: 0, symptom: {} }];
  for (const symptomName of Object.values(Symptoms)) {
    defaultStatistic[0].symptom[symptomName] = 0;
  }

  const statistics: Statistic[] = React.useContext(UserInfoContext).statistics || defaultStatistic;

  console.log(statistics);

  return (
    <>
      <SectionTitle title={STATISTIC_SECTION.title} />
      <Box pt={5}>
        {statistics.map((statistic, index) => (
          <StatisticDegree
            key={statistic.degree}
            title={STATISTIC_SECTION.nLevelContacts[index]}
            peopleUnit={STATISTIC_SECTION.peopleUnit}
            totalNum={statistic.totalNum}
            symptomCount={statistic.symptom}
          />
        ))}
      </Box>
    </>
  );
};

export default StatisticSection;
